import { Key } from "js/core/utilities/keys";

//This regex accepts any letters or numbers followed by a + and @ followed by letters or numbers followed by . and more letters or numbers
const EMAIL_VALIDATION_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const DELIMITERS_REGEX = /[\s\n,;]+/;

const TAG_DELIMITERS = [
    Key.TAB,
    Key.ENTER,
    Key.SPACE,
    Key.COMMA,
    Key.SEMICOLON,
];

export const FetchStatus = {
    UNSET: "unset",
    LOADING: "loading",
    LOADING_MORE: "loading-more",
    SUCCESS: "success",
    ERROR: "error"
};

export { EMAIL_VALIDATION_REGEX, TAG_DELIMITERS, DELIMITERS_REGEX };
